<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>MIS Report Adv</strong>
                
          </div>       
          <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
            <b-row v-if="userCountry=='KSA'&& isFinanceUser==1">
              <!-- {{pickuplocationmasterid}} -->
                  <b-col sm="6">
                   <b-col sm="12" >
                    <b-form-group label="Hub Name" 
                      :label-cols="4" >
                      <!-- @change="callListData()"  -->
                      <!-- <b-form-select  v-model="pickuplocationmasterid" @change="callListData()" name="pickuplocationmasterid" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.pickuplocationmasterid') }">
                        <option value="">--Please Select Hub--</option>
                        <option v-for="hub in hublistData"  v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
                    </b-form-select>  -->
                    <ejs-multiselect id='multiselect' key="hub_multiselect" placeholder="Please Select Hub" v-model="pickuplocationmasterid" @change="callListData()" :dataSource='destinationOptions'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                    ></ejs-multiselect> 
                    </b-form-group>
                   </b-col>
                  </b-col>
            </b-row>
            <b-row v-if="pickuplocationmasterid.length > 0 || (userCountry=='KSA'&&isFinanceUser==0)|| (userCountry=='ME'&&isFinanceUser==0)|| (userCountry=='ME'&&isFinanceUser==1)">           
              <b-col sm="4">
               <b-col sm="12" >
                    <b-form-group label="Delivery Agent" 
                      :label-cols="4" >  
                                     
                      <v-select id="mySelect" v-model="deliveryagentid" :options="this.data1" placeholder="Select Delivery Agent" name="deliveryagentid" v-validate="'required'" :class="{ danger: errors.has('deliveryagentid') }"
                      style="width:190px" :disabled="pickuplocationmasterid.length > 1">
                      </v-select>
                  
                      <span v-show="errors.has('deliveryagentid')" class="danger">
                          {{ errors.first('deliveryagentid') }}
                      </span>    
                    </b-form-group>  
                  </b-col>
              </b-col>

             

              <b-col sm="4">
                <b-form-group label="Pickup Type"  :label-cols="4" >
                  <b-form-select  name="Pickup" v-model="Pickup" class="mySelectBox" v-validate="'required'" >
                    <option :value="selected">--Selected Pickup Type--</option>
                    <option value="vendor">Vendor</option>
                    <option value="warehouse">Ware House</option>
                     <option value="3PL">3PL</option>
                  </b-form-select>                                
                </b-form-group>                   
              </b-col>


              
              
              
              <b-col sm="4">
                <b-form-group label="Delivery Status:"  :label-cols="4" >
                  <b-form-select v-model="shipmentstatus" name="shipmentstatus" class="mySelectBox" v-validate="'required'" :onclick="status()">
                    <option :value="selected">--Selected Status-</option>
                
                    <option value="totaldelivered">Total Delivered</option>
                    <option value="ofd">Total OFD</option>
                    <option value="handoverpending">Total NDR</option>
                    <option value="totalrto">Total RTO</option>
                    <option value="failedpickup">Total Failed</option>
                    <option value="inscan">Total Inscan</option>
                    <option value="notattempted">Not Attempted</option>
                   <option value="notassigned">Not Assigned</option>

                  </b-form-select>                                
                </b-form-group>                   
              </b-col>
            </b-row>
            <b-row v-if="pickuplocationmasterid.length > 0 || (userCountry=='KSA'&&isFinanceUser==0)|| (userCountry=='ME'&&isFinanceUser==0)|| (userCountry=='ME'&&isFinanceUser==1)">     
              <b-col sm="4">
                <b-col sm="12" >
                <b-form-group label="Shipment Type:"  :label-cols="5" >
                  <b-form-select v-model="shipmenttype" name="shipmenttype" class="mySelectBox" v-validate="'required'" >
                    <option :value="selected">--Selected type--</option>
                    <option value="reverse">Reverse</option>
                    <option value="forward">Forward</option>  
                     <option value="return">Return</option> 
                                
                  </b-form-select>  

                </b-form-group>  
                </b-col>                 
              </b-col>
                <b-col sm="4">
                <b-form-group label="From Date:"  :label-cols="4" >
                 <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                </v-date-picker>
                </b-form-group>
              </b-col>
               <b-col sm="4">
                <b-form-group label="To Date:"  :label-cols="4" >
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>
          
             
                             
            </b-row>
            <b-row v-if="pickuplocationmasterid.length > 0 || (userCountry=='KSA'&&isFinanceUser==0)|| (userCountry=='ME'&&isFinanceUser==0)|| (userCountry=='ME'&&isFinanceUser==1)">
              <b-col sm="4">
                 <b-col sm="12">
                <b-form-group label="Emirate City"  :label-cols="4" >
                  <b-form-select v-model="emiratescity" name="emiratescity" class="mySelectBox" v-validate="'required'" :disabled="pickuplocationmasterid.length > 1">
                    <option :value="selected">--Select City--</option>
                    <option v-for="city in localitycityname"
                    v-bind:value="city.locality_city_name">
                      {{city.locality_city_name}}
                    </option>
                    
                  </b-form-select>                                
                </b-form-group>  
                </b-col>                 
              </b-col>
               <b-col sm="4">
                 <b-col sm="12">
                <b-form-group label="Is Warranty"  :label-cols="4" >
                  <b-form-select v-model="getwarranty" name="getwarranty" class="mySelectBox" v-validate="'required'" >
                    <option :value="selected">--Select--</option>
                    <option value="1"> Yes </option>
                    <option value="0"> No </option>
                    
                  </b-form-select>                                
                </b-form-group>  
                </b-col>                 
              </b-col>
                <b-col sm="4" v-if="userCountry=='ME'">
                 <!-- <b-col sm="12"> -->
                  <!-- {{getDistinctCC}} -->
                <b-form-group label="Country Code"  :label-cols="4" >
                  <b-form-select v-model="getCountryCode" name="getCountryCode" class="mySelectBox"  >
                    <option :value="selected">--Select--</option>
                    <option v-for="code in getDistinctCC"
                    v-bind:value="code.countrycode">
                      {{code.countrycode}}
                    </option>
                    
                  </b-form-select>                                
                </b-form-group>  
                <!-- </b-col>                  -->
              </b-col>
         
  
            </b-row>
            <b-row v-if="pickuplocationmasterid.length > 0 || (userCountry=='KSA'&&isFinanceUser==0)|| (userCountry=='ME'&&isFinanceUser==0)|| (userCountry=='ME'&&isFinanceUser==1)">
              <b-col md="4" class="my-1">
               <b-col sm="12">
                <b-form-group >
                  
                    <b-form-input v-model="searching" placeholder="Type to Search"></b-form-input>
                   
                     
                </b-form-group>
              </b-col>
              </b-col>
               <!-- <b-col md="12"> -->
                <b-col sm="4" >
                   <!-- <b-col sm="12"> -->
                <b-form-group>
                  <!-- -->
                 <b-button type="submit"  @click="pickuplocationmasterid.length > 1 ? downloadConfirmationModal() : showCSV(1)" size="md" variant="primary" > Search</b-button>
               
                  <b-button type="submit" size="md" variant="primary" @click="clear()" style="margin-left: 10px"> clear</b-button>
                 
                  <b-button v-if="totalRows>0" type="submit" variant="primary" size="md" style="margin-left:20px;" @click="downloadCSV">Download </b-button>
                 
                </b-form-group>
              </b-col>
            <!-- </b-col> -->
             
           <!--  </b-row>
            <b-row> -->
   

              
           
            </b-row> 
          </b-form>  
          <b-row>
              <div id="overlay" >
                <div class="loader"></div>
              </div> 
              <b-col sm="12" class="text-right  margin-bottom =-13px;" >
                <b>Total Records :<span style="color:red;">{{ totalRows }}</span></b>   &nbsp;&nbsp;&nbsp;
              </b-col>
          </b-row>       
        
 
          <b-col sm="12" style="overflow:auto;">  
            <div style="float: left;" v-if="this.totalRows > 0">
               <span style="font-size:10px;padding:1px;border: 1px solid #A52A2A;color:#fff;background-color:#A52A2A;border-radius:3px;">CPCR</span> Indicates Client Pick Cancel Requested&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             </div> 
             <div style="float: left;" v-if="this.totalRows > 0">
               <span style="font-size:10px;padding:1px;border: 1px solid #4A7023 ;color:#fff;background-color:#4A7023 ;border-radius:3px;" >FOOD PRODUCT</span>&nbsp;Indicates
                Food Product Shipment
             </div>  

            <b-table  show-empty stacked="md" :busy="isBusy"   :items="items" :fields="fields"  :current-page="currentPage"  :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  @filtered="onFiltered" :bordered="bordered"  > 
                
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

                 <template slot="packagevalue" slot-scope="row">
                {{ (row.item.packagevalue && row.item.paymenttype!='prepaid') ? row.item.packagevalue:'0' }}
                </template>
                  <template slot="orderid" slot-scope="row">
                <span style="font-size:13px;padding:3px;border: 1px solid #A52A2A;color:#fff;background-color:#A52A2A;border-radius:5px;" v-if="row.item.is_mark_ofd == 2" >CPCR</span>
                <div style="width:60px">
                   {{row.item.orderid}}
                </div>
                 
                </template> 
                 <template slot="Awb" slot-scope="row">
                  
                   <div style="width:60px">
                     {{row.item.awbno}}
                   </div>
                  <span style="font-size:10px;padding:1px;border: 1px solid #4A7023 ;color:#fff;background-color:#4A7023 ;border-radius:3px;" v-if="row.item.is_foodproduct == 'YES'">FOOD PRODUCT</span>
                  <!-- <div v-if="row.item.is_foodproduct == 'YES'">
                
                   <a :href="foodproduct"> <i class="fa fa-shopping-basket" aria-hidden="true"  data-toggle="tooltip" title="Food Product" style="color: #0097e6; margin-left: 5px; ">&nbsp;</i></a>
                       </div> -->
                       
                 
                </template>
                  <template slot="vendoraddress" slot-scope="row">
                    <div style="width:90px">
                      {{row.item.vendoraddress}}
                    </div>
                  </template>
                   <template slot="destination" slot-scope="row">
                    <div style="width:74px">
                      {{row.item.destination}}
                    </div>
                  </template>
                   <template slot="shipstate" slot-scope="row">
                    <div style="width:50px">
                      {{row.item.shipstate}}
                    </div>
                  </template>
                 
                
            <template slot="show_details" slot-scope="row">
                <!-- <b-button v-if="row.item.logdata.length >0" size="sm" @click="info(row.item.logdata,row.item.awbno, row.index, $event.target)" class="mr-1 btn btn-info btn-block active">
                       Log
            </b-button>
            <br/> -->
         
                 
              <b-button size="sm" @click="row.toggleDetails(); MisReportdetails(row.item.awbno,row.detailsShowing); " class="mr-1" style="background: #b0c4de !important;color: #000 !important;">
                {{ row.detailsShowing ? 'Hide' : 'Show'}} 
              </b-button>

            
            </template>
            <template slot="row-details" slot-scope="row">
              <b-card>
                <b-row v-if="details.length >0">
                  <b-col sm="6">
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order id:</b></b-col>
                      <b-col>{{ details[0].orderid }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Awb No:</b></b-col>
                      <b-col>{{ details[0].awbno }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>City:</b></b-col>
                      <b-col>{{ details[0].branchcity }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Customer Name:</b></b-col>
                      <b-col>{{ details[0].customername }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Vendor Code:</b></b-col>
                      <b-col v-if="details[0].vendorcode =='fc0001'">ae001</b-col>
                     
                      <b-col  v-else>{{details[0].vendorcode}}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Origin:</b></b-col>
                      <b-col>{{ details[0].origin }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Vendor LocationID:</b></b-col>
                      <b-col>{{ details[0].vendorpincode }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Destination:</b></b-col>
                      <b-col>{{ details[0].destination }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Location ID:</b></b-col>
                      <b-col>{{ details[0].destinationpincode ? details[0].destinationpincode:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery boy:</b></b-col>
                      <b-col>{{ details[0].deliveryboy ? details[0].deliveryboy:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Mobile Number:</b></b-col>
                      <b-col>{{ details[0].dbmobilenumber ? details[0].dbmobilenumber:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order Status:</b></b-col>
                      <b-col>{{ details[0].orderstatus ? details[0].orderstatus:'-' }}</b-col>
                    </b-row>
                    
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Payment type:</b></b-col>
                      <b-col>{{ details[0].paymenttype ? details[0].paymenttype:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Package Value:</b></b-col>
                      <b-col>{{ details[0].packagevalue ? details[0].packagevalue:'-' }}</b-col>
                        <!-- <b-col>{{ (details[0].packagevalue && details[0].paymenttype!='prepaid') ? details[0].packagevalue:'0' }}</b-col> -->
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Ccheduled end km:</b></b-col>
                      <b-col>{{ details[0].scheduledendkm ? details[0].scheduledendkm:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Scheduled start km:</b></b-col>
                      <b-col>{{details[0].scheduledstartkm ? details[0].scheduledstartkm:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Total distance km:</b></b-col>
                      <b-col>{{ details[0].totaldistancekm ? details[0].totaldistancekm:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Is Try Buy:</b></b-col>
                      <b-col>{{ (details[0].istrybuy==1) ? 'Yes':'No' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Client Delivery Date:</b></b-col>
                      <b-col>{{ (details[0].clientedd) ? details[0].clientedd:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Vendor Name:</b></b-col>
                      <b-col>{{ details[0].vendor_name ? details[0].vendor_name:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                    <b-col sm="4" class="text-sm-right"><b>Zone Name:</b></b-col>
                      <b-col>{{ details[0].zone_name ? details[0].zone_name:'-' }}</b-col>
                    </b-row>
                 <!--    <b-row class="mb-2">
                    <b-col sm="4" class="text-sm-right"><b>Emirate City:</b></b-col>
                      <b-col>{{ details[0].locality_city ? details[0].locality_city:'-' }}</b-col>
                    </b-row> -->
                  </b-col>  
                  <b-col sm="6">
                   
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>order Creation :</b></b-col>
                      <b-col>{{ details[0].ordercreationtimestamp ? details[0].ordercreationtimestamp:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Pickup Check Intime:</b></b-col>
                      <b-col>{{ details[0].pickupcheckintime ? details[0].pickupcheckintime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order Confirmed Time:</b></b-col>
                      <b-col>{{ details[0].orderconfirmedtime ? details[0].orderconfirmedtime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Pickup Time:</b></b-col>
                      <b-col>{{ details[0].pickuptime ? details[0].pickuptime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Pickup Type:</b></b-col>
                      <b-col>{{ details[0].pickuptype ? details[0].pickuptype:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery check intime:</b></b-col>
                      <b-col>{{ details[0].deliverycheckintime ? details[0].deliverycheckintime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery Time:</b></b-col>
                      <b-col>{{ details[0].deliverytime ? details[0].deliverytime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Scheduled Start Time:</b></b-col>
                      <b-col>{{ details[0].scheduledstarttime ? details[0].scheduledstarttime:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Scheduled End Time:</b></b-col>
                      <b-col>{{ details[0].scheduledendtime ? details[0].scheduledendtime:'-' }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Total Time Consumed:</b></b-col>
                      <b-col>{{ details[0].totaltimeconsumed ? details[0].totaltimeconsumed:'-' }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Order Oreation Medium:</b></b-col>
                      <b-col>{{ details[0].orderoreationmedium ? details[0].orderoreationmedium:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivered By:</b></b-col>
                      <b-col>{{ details[0].deliveredby ? details[0].deliveredby:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Cancelled By:</b></b-col>
                      <b-col>{{ details[0].cancelledby ? details[0].cancelledby:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Delivery Notes:</b></b-col>
                      <b-col>{{ details[0].deliverynotes ? details[0].deliverynotes:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>NDR Reason:</b></b-col>
                      <b-col>{{ details[0].ndrreason ? details[0].ndrreason:'-' }}</b-col>
                    </b-row>
                      <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>NPR Reason:</b></b-col>
                      <b-col>{{ details[0].nprreason ? details[0].nprreason:'-' }}</b-col>
                    </b-row>
                   <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Ship lat long:</b></b-col>
                      <b-col>{{ details[0].shiplonglat ? details[0].shiplonglat:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Pick lat long:</b></b-col>
                      <b-col>{{ details[0].pickuplonglat ? details[0].pickuplonglat:'-' }}</b-col>
                    </b-row>
                     <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Vendor Address:</b></b-col>
                      <b-col>{{ details[0].vendor_address ? details[0].vendor_address:'-' }}</b-col>

                       
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="4" class="text-sm-right"><b>Food Product:</b></b-col>
                      <b-col>{{ details[0].is_foodproduct=='YES' ? 'YES':details[0].is_foodproduct=='NO'?'NO':'-'}}</b-col>
                    </b-row>

                  
                  </b-col> 
                  <b-col sm="12">
                  <div slot="footer" class="text-right">
                   <b-button size="sm" @click="row.toggleDetails" style="background: #b0c4de !important;color: #000 !important;">Hide Details</b-button>
                  </div> 
                 </b-col> 
                </b-row> 

              </b-card>
            </template>

          </b-table>
        </b-col>
          <b-col md="6" class="my-1" v-if="totalRows>0">
                        <paginate
                              :page-count="noofpages"
                              :page-range="10"
                              :margin-pages="2"
                              :click-handler="clickCallback"
                              :prev-text="'Prev'"
                              :next-text="'Next'"
                              :container-class="'pagination'"
                              :page-class="'page-item'">
                            </paginate>
          </b-col>

          <b-modal title="Confirmation Box" v-model="toggleInfo" size="sm"
            @ok="toggleInfo = false">
            <template slot="modal-header" slot-scope="{ close }">
              <h5>Confirmation</h5>
            </template>
            <template slot="default" slot-scope="{ hide }">
              <form>
                <div class="modal-background"></div>
                <div class="modal-card">
                  <section class="modal-card-body">
                    <span> Do you want to download the report ?</span>
                  </section>
                  <footer slot="modal-footer">
                    <b-button variant="primary" size="sm" @click="downloadCSV">Yes</b-button>
                  </footer>
                </div>
              </form>
            </template>
            <footer slot="modal-footer" slot-scope="{ cancel }">
              <b-button size="sm" variant="danger" @click="downloadConfirmationModal">
                Cancel
              </b-button>
            </footer>
          </b-modal>
        </b-card>
      </b-col>
    </b-row>    
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
export default {
  data: function() {
    return {
      data: [], 
      items:[],    
      selected:'',
      isBusy: false,   
      orderflow:'',
      Pickup:'',
      email:'',
      shipmenttype:'',
      shipmentstatus:'',
      emiratescity:'',
      getwarranty:'',
      getDistinctCC:[],
      getCountryCode:'',
      localitycityname:[],
      localityid:'',
      hubid:'',
      data1:[],
      // perPage:  10,
      pageNum:1,
      noofpages:'',
      pageOptions: [5, 10, 15],
      sortBy: true,
   
      awbno:'',
      deliveryagentid:'',
      agentmaster: [],
      showdata: [],
      selectDateFrom: new Date(),
      selectDateTo:new Date(),
      hubdata:[],
      details:[],
      progressbar:[],
      orderid:[],
     foodproduct:'',
      fields: [
    
          { key: 'orderid', label:'Orderid',sortable: true,sortDirection:'desc',tdClass: 'orderidClass'},
          { key: 'Awb', label: 'AWB-Number', sortable: true,tdClass: 'awbClass'},
          { key: 'customername', label: 'Customer Name', sortable: true},
          { key: 'vendoraddress', label: 'Pick Up Address', sortable: true,tdClass: 'pickupClass'},          
          { key: 'destination', label: 'Destination Address', sortable: true ,tdClass: 'desitnationClass'}, 
          { key: 'countrycode', label: 'Destination Country', sortable: true ,tdClass: 'countryClass'},
          { key: 'shipstate', label: 'Emirate City', sortable: true ,tdClass: 'countryClass'},  
          { key: 'deliverystatus', label: 'Delivery status', sortable: true,tdClass: 'statusClass' },
          { key: 'orderstatus', label: 'Order Status', sortable: true,tdClass: 'statusClass' },
          { key: 'paymenttype', label: 'Payment Type' , sortable: true},
           { key: 'pickuptype', label: 'Pickup Type' , sortable: true},
          { key: 'show_details', label: 'Action',tdClass: 'nameOfTheClass'},
         

        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:  20,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        searching:'',
        awbno:'',
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        hublistData:[],
        // pickuplocationmasterid:'',
        userCountry:'',
        isFinanceUser:'',

        // multiple hub selection values
        pickuplocationmasterid : [],
        agentmaster:[],
        agentfields: { text: 'name', value: 'id' },
        destinationOptions: [],
        showSelectAll : true,
        allowCustomValue : true,

        //confirmation box
        toggleInfo: false,
    };
  },
  computed: {
    // sortOptions() {
    //     // Create an options list from our fields
    //     return this.fields
    //       .filter(f => f.sortable)
    //       .map(f => {
    //         return { text: f.label, value: f.key }
    //       })
    //   }
  },
  created: function() {
   
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    console.log("userInfo",userInfo);
    this.email=userInfo.sysemailid;
     this.userCountry=userInfo.country;
     this.isFinanceUser=userInfo.is_finance_superadmin;
    this.hubid=`${userInfo.pickuplocationmasterid}`;

    if( this.isFinanceUser==1 && this.userCountry=='KSA'){
      this.gethublist();
    }else{
      this.displayHubdata();
      this.displaydeliveryagent();
      this.emiratesfun();
    }
   
    
   
    if(this.userCountry=='ME'){
      this.getDistinctCountryCode();
    }
    
    if((this.userCountry=='KSA' && this.isFinanceUser==0)||(this.userCountry=='ME' && this.isFinanceUser==0)||(this.userCountry=='ME' && this.isFinanceUser==1)){

       this.showCSV(this.pageNum);
    
    }
   
  },
  methods: {
    info(item, shipmentid,index, button) {
      
      this.progressbar  = item;
      this.infoModal.title = 'Shipment Log - '+shipmentid;
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    validateForm(scope) {
      // alert("Inn");
      // this.$validator.validateAll(scope).then(result => {
      //   if (result) {          
      //     this.showCSV(1);
      //   }
      // });
    },
    trybuyaddawb:function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // alert(userInfo.pickuplocationmasterid);
      const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
      
      };
       this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getmisreportadvanced`,obj)
        .then(result => {
          if (result.data.returnmsg == "successful") {

            this.getDownloadCsvObject(result.data.returnvalue);
          
          //  alert('MIS Report Downloaded Successfully');
            this.$fire({
                  text:"MIS Report Downloaded Successfully",
                  type: "success",
                  timer: 30000
                }); 
            //document.getElementById("loader").style.display = 'none';
          } else {
            //  alert(result.body.returnmsg);
          this.$fire({
                  text:result.body.returnmsg,
                  type: "error",
                  timer: 30000
                }); 
      
          }
        }).catch(ex => {
          console.log("error-----", ex);
        });
     }, 
    getDownloadCsvObject: function(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear(); var ce
      var today = dd + "" + mm + "" + yyyy;
      var data, filename, link;
      filename = "MISReport_" + today + ".csv";
      var csv = this.convertArrayOfObjectsToCSV({
        data: csvData
      });
      if (csv == null) return;
      filename = filename || "export.csv";
      if (!csv.match(/^data:text\/csv/i)) {
        csv = "data:text/csv;charset=utf-8," + csv;
      }
      data = encodeURI(csv);
      link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.removeChild(link);
    },

    // function for Emirates City Dropdown
    emiratesfun:function(){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var emiobj={
        hub_id:`${userInfo.pickuplocationmasterid}`,
      }
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getemiratecitylist`,emiobj)
        .then(result => {
          // console.log('hii',result);
       if (result.body.returnmsg == 'Successful') {
        // alert("hii");
          this.localitycityname=result.body.returnvalue;
          // this.localityid=result.body.returnvalue[0].locality_id;
          // console.log("IIIIIIIddddddddd",this.localityid);
       }
       else{

       }
        });

    },
    // function End
    //Country CODE 
    getDistinctCountryCode(){
     var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var emiobj={
        // hub_id:`${userInfo.pickuplocationmasterid}`,
      }
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getDistinctCountry`,emiobj)
        .then(result => {
          // console.log('hii',result);
       if (result.body.returnmsg == 'Successful') {
        // alert("hii");
          this.getDistinctCC=result.body.returnvalue;
          console.log("Yrss",this.getDistinctCC);
         
       }
       else{
        this.getDistinctCC=[];
       }
        }).catch(ex => {
            console.log("error-----", ex);
          });

   },//End

    downloadCSV: function() {
       document.getElementById("overlay").style.display = "block";
       if(this.pickuplocationmasterid.length > 1){
        this.toggleInfo = !this.toggleInfo;
       }
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var selectedHubid=(this.userCountry=='KSA' && this.isFinanceUser==1)?this.pickuplocationmasterid:`${userInfo.pickuplocationmasterid}`
        console.log("Hub",selectedHubid);
      var email=this.email;
      var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
      var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
      var orderflow=(this.orderflow!=null)? this.orderflow:"";
      var Pickup=(this.Pickup!=null)? this.Pickup:"";
      var shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
      var shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
      var deliveryagentid=(this.deliveryagentid.key!=null)? this.deliveryagentid.key:"";
     var emiratescity=(this.emiratescity!=null)?this.emiratescity:"";
     var getwarranty=(this.getwarranty!=null)?this.getwarranty:"";
     var getCountryCode=(this.getCountryCode!=null)?this.getCountryCode:"";
       if(shipmentstatus=="notassigned")
        {

         var csvObj = {
             shipmentstatus:shipmentstatus,
             sysusermasterid:`${userInfo.sysusermasterid}`, 
              hub_id:`${selectedHubid}`,
              countrycode:`${userInfo.countrycode}`,
              is_finance_superadmin:userInfo.is_finance_superadmin,
             // page_no:1,
           };

        }
        else if(this.searching)
        {
          var csvObj = {
             fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            // serviceid: `${this.hubid}`,
             serviceid: `${selectedHubid}`,
            orderflow:orderflow,
            Pickup:Pickup,
            shipmentstatus:shipmentstatus,
            shipmenttype:shipmenttype,
            deliveryagentid:this.deliveryagentid.key,
            shippingid:'',
            email:`${this.email}`,
            search_text:this.searching,
            sysusermasterid:`${userInfo.sysusermasterid}`, 
             hub_id:`${selectedHubid}`,
            locality_city_name:emiratescity,
            iswarrantyshipment:getwarranty,
            countrycode:getCountryCode,
            is_finance_superadmin:userInfo.is_finance_superadmin,
             // page_no:1,
           };
         
        }
        else{
          if(this.deliveryagentid.key==undefined)
          {
          var   deliveryagentid="";
          }
          else
          {
           var  deliveryagentid=this.deliveryagentid.key;
          }
          var csvObj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            // serviceid: `${this.hubid}`,
             serviceid: `${selectedHubid}`,
            orderflow:orderflow,
            Pickup:Pickup,
            shipmentstatus:shipmentstatus,
            shipmenttype:shipmenttype,
            deliveryagentid:deliveryagentid,
            shippingid:'',
            email:`${this.email}`,
            sysusermasterid:`${userInfo.sysusermasterid}`,
             hub_id:`${selectedHubid}`,
             locality_city_name:emiratescity,
             iswarrantyshipment:getwarranty,
             countrycode:getCountryCode,
             is_finance_superadmin:userInfo.is_finance_superadmin,
            // page_no:1,

          };
         
        }
 

      //console.log(csvObj);
      
        // var queryString ="?"+ Object.keys(csvObj).map(key => key + '=' + csvObj[key]).join('&');
// console.log(queryString);
      if(formatdateto< fromdate){
        // alert('To date need to be grater than From date');
        this.$fire({
                  text:"To date need to be grater than From date",
                  type: "error",
                  timer: 30000
                }); 
          
      }
      //var r = Math.random().toString(36).substring(3);
      //old api-
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getmisreportcsv_advanced`,csvObj)
        .then(result => {
          // console.log('hii',result);
          document.getElementById("overlay").style.display = "none";
           if(result.body=="success")
         {
         // alert("Please Check Ur Mail For Downlod Link")
          this.$fire({
                  text:"Please Check Your Mail For Downlod Link",
                  type: "success",
                  timer: 30000
                }); 
       }
       else
       {
        // alert("Can not Download");
        this.$fire({
                  text:"Can not Download",
                  type: "error",
                  timer: 30000
                }); 

       }
         // console.log(result.url);
       // window.location.href =result.url;
        });
        
    },




  clickCallback (pageNum)
       {
      //   alert(" i m in pagination task");
      // alert(pageNum)
      this.showCSV(pageNum);
    },
     showCSV: function(pagee) {
 
       var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
 
       this.isBusy = true;
      
      var center = this.hubid;
      if(center == undefined){
     
          this.$fire({
                  text:"Please select center",
                  type: "warning",
                  timer: 30000
                }); 
        
      }else{
        let selectedHubid=(this.userCountry=='KSA' && this.isFinanceUser==1)?this.pickuplocationmasterid:`${userInfo.pickuplocationmasterid}`
        console.log("Hub",selectedHubid);
        let email=this.email;
        let fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        let formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
        let orderflow=(this.orderflow!=null && this.orderflow!='')? this.orderflow:"both";
         let Pickup=(this.Pickup!=null && this.Pickup!='')? this.Pickup:"";
        //  console.log("deliveryagentid----------------",this.deliveryagentid);
        let deliveryagentid=(this.deliveryagentid!=null)? this.deliveryagentid.key:"";
        // console.log("deliveryagentid===========",deliveryagentid);
        let shipmentstatus=(this.shipmentstatus!=null)? this.shipmentstatus:"";
        let shipmenttype=(this.shipmenttype!=null)? this.shipmenttype:"";
        let emiratescity=(this.emiratescity!=null)?this.emiratescity:"";
         let getwarranty=(this.getwarranty!=null)?this.getwarranty:"";
         let getCountryCode=(this.getCountryCode!=null)?this.getCountryCode:"";
        if(shipmentstatus=="notassigned")
        {

         var csvObj = {
             shipmentstatus:shipmentstatus,
             page_no:1,
             // hub_id:`${userInfo.pickuplocationmasterid}`,
             hub_id:`${selectedHubid}`,
             countrycode:`${userInfo.countrycode}`,
             locality_city_name:emiratescity,
             is_finance_superadmin:userInfo.is_finance_superadmin,
             // iswarrantyshipment:
           };

        }
        else if(this.searching)
        {
          var csvObj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            // serviceid: `${this.hubid}`,
            serviceid: `${selectedHubid}`,
            orderflow:orderflow,
            Pickup:Pickup,
            shipmentstatus:shipmentstatus,
            shipmenttype:shipmenttype,
            deliveryagentid:deliveryagentid,
            // shippingid:'',
            email:email,
            page_no:pagee,
            search_text:this.searching,
             // hub_id:`${userInfo.pickuplocationmasterid}`,
             hub_id:`${selectedHubid}`,
              // countrycode:`${userInfo.countrycode}`,
            locality_city_name:emiratescity,
            iswarrantyshipment:getwarranty,
            countrycode:getCountryCode,
            is_finance_superadmin:userInfo.is_finance_superadmin,
           };
         
        }
        else{

          var csvObj = {
            fromdate: `${fromdate}`,
            todate:`${formatdateto}`,
            // serviceid: `${this.hubid}`,
            serviceid: `${selectedHubid}`,
            orderflow:orderflow,
            Pickup:Pickup,
            shipmentstatus:shipmentstatus,
            shipmenttype:shipmenttype,
            deliveryagentid:deliveryagentid,
            // shippingid:'',
            email:`${this.email}`,
            page_no:pagee,
            search_text:this.searching,
             // hub_id:`${userInfo.pickuplocationmasterid}`,
             hub_id:`${selectedHubid}`,
            //  countrycode:`${userInfo.countrycode}`,
              locality_city_name:emiratescity,
              iswarrantyshipment:getwarranty,
              countrycode:getCountryCode,
              is_finance_superadmin:userInfo.is_finance_superadmin,
          };
         
        }
 

        if(formatdateto< fromdate){
          //  alert('To date need to be greater than From date');  
           this.$fire({
                  text:"To date need to be grater than From date",
                  type: "warning",
                  timer: 30000
                });         
        }
       console.log("csvObj",csvObj)
        this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmisreportadvanced`, csvObj)
          .then(result => {
            // console.log("result",result);
             this.isBusy = !this.isBusy;

          //  document.getElementById("loader").style.display = 'none'
            if (result.body.returnmsg && result.body.returnmsg === 'successful') {
                 // console.log('mis',result.body.returnvalue[0]);
                this.showdata = result.body.returnvalue[0].shippingidlist;
                this.items  = result.body.returnvalue[0].shippingidlist;
               // console.log('eeeeee',this.items );
               this.foodproduct=result.body.returnvalue[0].shippingidlist.is_foodproduct;
               // console.log("ttttt",this.foodproduct);
                this.totalRows = result.body.returnvalue[0].totalrecords;  
                 // console.log('row',this.totalRows);
           this.noofpages=parseInt(this.totalRows)/20;
           
           this.noofpages=Math.ceil( this.noofpages);        
            }else{
             this.showdata = []
              this.items  = [];
              this.totalRows = 0;               
             
            }
          })
          .catch(ex => {
            console.log("error-----", ex);
          });
      }
    },


    
    status: function() {
     
    if(this.shipmentstatus=="notassigned")
     {

     var csvObj = {
          
          shipmentstatus:"notassigned"
         
        };
        
      }
     },
  //Hub List Function
  // gethublist: function(){
  //       var userdata = localStorage.getItem('userData')
  //     var userInfo = JSON.parse(userdata)
     
  //     const obj = {
  //       hub_id:`${userInfo.pickuplocationmasterid}`,
      
  //     };
     
  //     this.$http
  //       .post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,obj)
  //       .then(result => {
          
  //         if(result.body.returnmsg=='Successful'){
  //         this.hublistData = result.body.returnvalue;
        
  //         }
          
  //       })
  //       .catch(ex => {
  //         alert('error-----',ex);
  //       });
  //   },   

  gethublist: function(){
        var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     
      const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
      
      };
     
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,obj)
        .then(result => {
          
          if(result.body.returnmsg=='Successful'){
            this.hublistData = result.body.returnvalue;
            result.body.returnvalue.forEach(item=>{
              let tempObj = {id: item.pickuplocationmasterid, name: item.pickuplocationname}
              this.destinationOptions.push(tempObj)
            })
        
          }
          
        })
        .catch(ex => {
          console.log('error-----',ex);
        });
    }, 

    //Hub List Function End
    callListData:function(){
      if(this.pickuplocationmasterid.length == 0){
        this.$fire({
                  text:"Please Select Hub",
                  type: "warning",
                  timer: 30000
                }); 

                this.searching="";
                this.deliveryagentid="";
                this.Pickup="";
                this.shipmentstatus="";
                this.shipmenttype="";
                this.getwarranty="";
                this.emiratescity="";
                this.selectDateFrom=new Date();
                this.selectDateTo=new Date();
                this.filter="";
                this.getCountryCode='';
                this.totalRows=0;
                this.showdata=[];
                this.items=[];
                

      }
      else if(this.pickuplocationmasterid.length == 1){
        this.displaydeliveryagent();
        this.displayHubdata(); 
        this.emiratesfun();
      }
      else{
        this.deliveryagentid="";
        this.emiratescity="";
        this.totalRows=0;
        this.items=[];
      }
    },
    
    convertArrayOfObjectsToCSV: function(args) {
       var result, ctr, keys, columnDelimiter, lineDelimiter, data;
       data = args.data || null;
       if (data == null || !data.length) {
         return null; var ce
       }
      

       columnDelimiter = args.columnDelimiter || ",";
       lineDelimiter = args.lineDelimiter || "\n";

       //.slice(0,-4)
       keys = Object.keys(data[0]);
       
       result = "";
       result += keys.join(columnDelimiter);
       result += lineDelimiter;
       data.forEach(function(item) {
       var logdata = item['logdata'];
       var attempt = item['attempt'];
       var allowcheckedin = item['allowcheckedin']

        item['pickupcheckintime'] = null;
        item['pickuptime'] = null;

        item['orderconfirmedtime'] = null;
        item['deliverytime'] = null;
        item['ordercreationtimestamp'] = "'"+item['ordercreationtimestamp'];
        item['scheduledstarttime'] = "'"+item['scheduledstarttime'];
        item['scheduledendtime'] = "'"+item['scheduledendtime'];

         if(logdata!==null){

           logdata.forEach(function(itm){
             let mydate = new Date(itm.createddate);
             let month=mydate.getMonth()+1;
             let createddate="'"+mydate.getFullYear()+"-"+month+"-"+mydate.getDate()+" "+mydate.getHours()+":"+mydate.getMinutes();
             switch(itm.process) {
               case 'BookingDone':
                   if(attempt !== null)
                   {
                       if(attempt == itm.attempt)
                       {
                         item['orderconfirmedtime'] = createddate.toString();
                         break;
                       }
                    }else {
                       item['orderconfirmedtime'] = createddate.toString();
                      break;
                    }
               case 'OFD':
                    if(attempt !== null)
                   {
                       if(attempt == itm.attempt)
                       {
                         if(allowcheckedin == 'true'){
                           item['pickupcheckintime'] = item['pickupcheckintime1'];
                           item['pickuptime'] = createddate.toString();
                           break;
                         }else {

                           item['pickupcheckintime'] = createddate.toString();
                           item['pickuptime'] = createddate.toString();
                           break;
                         }
                       }
                  }else {
                    if(allowcheckedin == 'true'){
                      item['pickupcheckintime'] = item['pickupcheckintime1'];
                      item['pickuptime'] = createddate.toString();
                      break;
                    }else {
                      item['pickupcheckintime'] = createddate.toString();
                      item['pickuptime'] = createddate.toString();
                      break;
                    }
                  }
               case 'DLV':
                 if(attempt !== null)
                 {
                     if(attempt == itm.attempt)
                     {
                        if(allowcheckedin == 'true'){
                           item['deliverycheckintime'] = item['deliverycheckintime1'];
                           item['deliverytime'] = createddate.toString();
                           break;
                        }else {
                          item['deliverycheckintime'] = createddate.toString();
                          item['deliverytime'] = createddate.toString();
                          break;
                        }
                     }
                }else {
                    if(allowcheckedin == 'true'){
                       item['deliverycheckintime'] = item['deliverycheckintime1'];
                       item['deli var ceverytime'] = createddate.toString();
                       break;
                    }else {
                      item['deliverycheckintime'] = createddate.toString();
                      item['deliverytime'] = createddate.toString();
                      break;
                    }
                }

                case 'NDR':
                  if(attempt !== null)
                  {
                      if(attempt == itm.attempt)
                      {
                        item['deliverycheckintime'] = null;
                        item['deliverytime'] = null;
                        break;
                      }
                 }else {
                        item['deliverycheckintime'] = null;
                        item['deliverytime'] = null;
                     break;
                 }
             }
           });
         } else {
           item['deliverytime'] = '';
           item['orderconfirmedtime'] = '';
           item['pickupcheckintime'] = '';
           item['pickuptime'] = '';
         }
         ctr = 0;
        

         keys.forEach(function(key) {
          // console.log('--------------------');
          // console.log(key);
              //       console.log('-----datta---------------');
//&& key!='logdata'
           if (ctr > 0) result += columnDelimiter;
           if (item[key] != null && key!='logdata') {

            if(key=='origin'){
                var str2=item[key];
                str2=str2.replace('#','');
                result += '"' +str2 + '"';
             }else{
             result += '"' + item[key] + '"';
             }      
           }           
           
           ctr++;
         });
         result += lineDelimiter;
       });
     //  document.getElementById("loader").style.display = 'none';

       return result;
     },
    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");

    },
      clear: function() {
         // this.pickuplocationmasterid="";
         this.searching="";
         this.deliveryagentid="";
         this.Pickup="";
         this.shipmentstatus="";
         this.shipmenttype="";
         this.getwarranty="";
         this.emiratescity="";
         this.selectDateFrom=new Date();
         this.selectDateTo=new Date();
          this.filter="";
          this.getCountryCode='';
          
          // if(this.pickuplocationmasterid.length > 1){
          this.pickuplocationmasterid=[];
          this.showdata = []
          this.items  = [];
          this.totalRows = 0; 
          // }else{
          //   this.showCSV(this.pageNum);
          // }
         
   
      
    },
   
    displayHubdata: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      // const deliveryagentobj = {
      //   hub_id:`${userInfo.pickuplocationmasterid}`,
      // }
      this.$http.post(`${CONSTANTS.API_URL}/P2PReports/GetAllHubListMaster`)
        .then(result => {
          this.hubdata = result.body.returnvalue;
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
    },



    MisReportdetails: function(shipmentid,showhide) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
        var showhides=showhide;
      
 if(showhides)
 {

 }
 else{
      
 
 var awbno = shipmentid;
 //alert(awbno)

  var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
        var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
         var selectedHubid=(this.userCountry=='KSA' && this.isFinanceUser==1)?this.pickuplocationmasterid:`${userInfo.pickuplocationmasterid}`
        console.log("Hub",selectedHubid);
       
        var shippingidobj = {
          fromdate: `${fromdate}`,
          todate:`${formatdateto}`,
          // serviceid: `${this.hubid}`,
          serviceid: selectedHubid.toString(),
          shippingid: `${awbno}`,
          hub_id:selectedHubid.toString(),
        };

      this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getmisreportdetails`,shippingidobj)
        .then(result => {
          this.details = result.body.returnvalue;
          console.log(this.details);
        })
        .catch(ex => {
          console.log('error-----', ex)
        });
      }
    },




    displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      //agentmaster
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
         hub_id:`${userInfo.pickuplocationmasterid}`,
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          // this.agentmaster = result.body
          this.data1 = result.body

           var data = [];
 
              result.body.forEach(function (srData) {
                data.push({
                  key:srData.deliveryagentmasterid,
                  label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
                });
              });
              this.data1 = data;
          // console.log("delivery11",this.data1);
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },

    downloadConfirmationModal(){
      this.toggleInfo = !this.toggleInfo;
    },

  }
};
</script>

<style lang="css">
.popover-container {
  width: 100%;
}
.popover-container input {
  -moz-appearance: none;
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
  max-width: 100%;
  width: 100%;
}
.table tr th {
  color: #fff !important;
  padding: .2rem!important;
}
.table thead,
.table thead tr:hover {
  background: #333 !important;
}
.table button {
  background: #b0c4de !important;
  color: #000 !important;
}
.table tr:hover {
  background: #efefef;
}
tbody tr:nth-child(even) {
  background: #f2f2f2;
}
tbody tr:nth-child(odd) {
  background: #fff;
}
.registerbox {
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  width: 1244px;
  background-color: #fff;
}
hr {
  margin-bottom: 0px;
}
.error {
  color: red;
}
button.editbtn {
  border: none;
  background: transparent !important;
}
.label {
  text-align: left;
}
.select {
  width: 100%;
}
  .nameOfTheClass {
   max-width: 450px !important;
}
.orderidClass{
   max-width: 110px !important;
}
.awbClass{
  max-width: 110px !important;
}
.statusClass{
 max-width: 110px !important; 
}
.desitnationClass{
  max-width: 110px !important; 
}
.countryClass{
 max-width: 60px !important;  
}
.pickupClass{
  max-width: 100px !important; 
}
#overlay {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/*tbody tr:nth-child(odd) {
    background: darkgray !important;
}*/
</style>
